import { render, staticRenderFns } from "./gatherUpload.vue?vue&type=template&id=228e8e14&scoped=true"
import script from "./gatherUpload.vue?vue&type=script&lang=js"
export * from "./gatherUpload.vue?vue&type=script&lang=js"
import style0 from "./gatherUpload.vue?vue&type=style&index=0&id=228e8e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e8e14",
  null
  
)

export default component.exports